// src/utils/panelNaming.js
//
// Panel adı otomatik oluşturma — kat türü + numara + kattaki sıra
// (örn. "1-N.K.T.-1", "Z.K.T.-2"). PanelTypeMenu (mevcut panel düzenleme)
// ve useElectricalPanelWiring (yeni panel oluşturma) ortak kullanır.

import { FLOOR_TYPES } from '../redux/floorPlanSlice';
import { getActiveFloorPlanId, getGlobalDocumentBounds } from './getActiveFloorPlanId';

// Kat türü → kısa kod
export const FLOOR_TYPE_CODES = {
  [FLOOR_TYPES.NORMAL]:    'N.K.T.',
  [FLOOR_TYPES.BASEMENT]:  'B.K.T.',
  [FLOOR_TYPES.GROUND]:    'Z.K.T.',
  [FLOOR_TYPES.MEZZANINE]: 'A.K.T.', // Asma
  [FLOOR_TYPES.GALLERY]:   'G.K.T.', // Galeri
  [FLOOR_TYPES.ROOF]:      'Ç.K.T.',
};

// Tek-katlı tipler (numerik prefix ATILIR — sadece kod + sıra).
const NUMERIC_FLOOR_TYPES = new Set([FLOOR_TYPES.NORMAL, FLOOR_TYPES.BASEMENT]);

/**
 * Bir panele varsayılan ad üretir: "{kat no}-{tür kodu}-{kattaki sıra}".
 * Tek-katlı tipler için: "{tür kodu}-{kattaki sıra}".
 *
 * @param {Object} options
 * @param {{x:number,y:number,z?:number}} options.position - Panel pozisyonu
 * @param {Array}  options.floorPlans - selectAllFloorPlans / aynı yapı
 * @param {Array}  options.allComponents - simpleSupply.components
 * @param {string} [options.excludeId] - Bu id'li panel sıraya dahil edilmez (kendisini sayma)
 * @param {string} [options.componentId] - Mevcut panelin id'si (sıra hesabında bu id varsa onun pozisyonunu kullan)
 * @returns {string} Default ad veya '' (kat plan tespit edilemediyse)
 */
export function buildDefaultPanelName({ position, floorPlans, allComponents, excludeId, componentId }) {
  if (!position || !floorPlans?.length) return '';

  const bounds = getGlobalDocumentBounds();
  if (!bounds?.length) return '';

  const fpId = getActiveFloorPlanId(position, bounds);
  const fp = floorPlans.find(p => p.id === fpId);
  if (!fp) return '';

  const code = FLOOR_TYPE_CODES[fp.type] || 'PANO';

  // Aynı kat plan'ındaki panelleri bul (creation order)
  const panelsOnFloor = (allComponents || []).filter(c => {
    if (c.kind !== 'dist_panel' && c.kind !== 'panel') return false;
    if (!c.position) return false;
    if (excludeId && c.id === excludeId) return false;
    return getActiveFloorPlanId(c.position, bounds) === fpId;
  });

  let order;
  if (componentId) {
    const idx = panelsOnFloor.findIndex(c => c.id === componentId);
    order = idx >= 0 ? idx + 1 : panelsOnFloor.length + 1;
  } else {
    // Yeni panel oluşturma akışı — mevcut sayı + 1
    order = panelsOnFloor.length + 1;
  }

  if (NUMERIC_FLOOR_TYPES.has(fp.type)) {
    const num = Math.abs(fp.number ?? 1);
    return `${num}-${code}-${order}`;
  }
  return `${code}-${order}`;
}
